import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

import { Cadastro, Tipos } from "data/interfaces";
import * as api from "services/firebase";

import * as images from "../../images/images";
import Busca from "./components/busca";
import Detalhe from "./components/detalhe";
import {
  Picture,
  Title,
  SubTitle,
  Container,
  Person,
  Information,
  Endereco,
  Telefone,
  Imagem,
  Back,
} from "./styles";

function Profissional() {
  const primeiro = {} as Cadastro;
  const [profissionais, setProfissionais] = useState<Cadastro[]>([]);
  const [profissionaisTmp, setProfissionaisTmp] = useState<Cadastro[]>([]);
  const [cadastroSelecionado, setCadastroSelecionado] = useState<Cadastro>(
    primeiro
  );
  const [position, setPosition] = useState<number>(0);

  const { id, share } = useParams();

  const history = useHistory();

  useEffect(() => {
    if (share === "1") {
      const detalheDiv = document.querySelector("#detalhe");
      detalheDiv?.setAttribute("style", "display: block");
      const listaDiv = document.querySelector("#lista");
      listaDiv?.setAttribute("style", "display: none");
    } else {
      const detalheDiv = document.querySelector("#detalhe");
      detalheDiv?.setAttribute("style", "display: none");
      const listaDiv = document.querySelector("#lista");
      listaDiv?.setAttribute("style", "display: block");
    }
  }, [id, share]);

  useEffect(() => {
    api.getListaCadastro(Tipos.ESPECIALISTAS, (cadastros: Cadastro[]) => {
      setProfissionais(cadastros);
      setProfissionaisTmp(cadastros);
      // setCadastroSelecionado(cadastros[0]);
      if (share) {
        const itemShare: Cadastro = cadastros
          .filter((item) => item.key === id)
          .shift() as Cadastro;
        if (itemShare) {
          setCadastroSelecionado(itemShare);
        }
      }
    });
  }, [id, share]);

  function handleChange(newValue: Cadastro[]) {
    setProfissionais(newValue);
  }

  function handleSelect(newValue: Cadastro) {
    setCadastroSelecionado(newValue);
    // const detalheDiv = document.querySelector("#detalhe");
    // detalheDiv?.setAttribute("style", "display: block");
    // const listaDiv = document.querySelector("#lista");
    // listaDiv?.setAttribute("style", "display: none");
    // setPosition(window.scrollY);
    // window.scrollTo(0, 0);
    history.push("/profissional/0/1");
  }

  function handleBack() {
    // const detalheDiv = document.querySelector("#detalhe");
    // detalheDiv?.setAttribute("style", "display: none");
    // const listaDiv = document.querySelector("#lista");
    // listaDiv?.setAttribute("style", "display: back");
    // window.scrollTo(0, position);
    history.push("/");
  }

  return (
    <>
      <div id="lista" style={{ display: "none" }}>
        <Imagem src={images.imgMedico} alt="foto" />
        <Busca
          cadastros={profissionais}
          cadastrosTmp={profissionaisTmp}
          onChange={handleChange}
        />
        <Container>
          {profissionais.map((cadastro) => (
            <Person
              key={cadastro.key}
              onClick={() => {
                handleSelect(cadastro);
              }}
            >
              <Picture src={cadastro.urlImage} alt="Foto" />
              <Information>
                <Title fontSize={16}>{cadastro.nome.toLowerCase()}</Title>
                <SubTitle>{cadastro.especialidade}</SubTitle>
                <Telefone>{cadastro.telefone}</Telefone>
                <Endereco>{cadastro.endereco}</Endereco>
              </Information>
            </Person>
          ))}
        </Container>
      </div>
      <div id="detalhe" style={{ display: "block" }}>
        <Back
          onClick={() => {
            handleBack();
          }}
        />
        <Detalhe cadastro={cadastroSelecionado} />
      </div>
    </>
  );
}

export default Profissional;
